import { LoginResponse } from '../types/register';
import { Api } from './Api';

type Address = {
    address: string
}

type RegisterResponse = {
    code: number,
    data: string
}

type RegisterPayload = {
    device_id: string,
    document_id?: string,
    flow: string,
    hash_address: string,
    nickname?: string,
    password: string
}

const createPayloadLoginAndRegister = (hash_address:string, password:string, nickname?:string, chain?:string) => {
    if(!nickname) nickname = '';
    return {
        flow: 'hash_address',
        hash_address,
        password,
        device_id: '1111-2222',
        nickname,
        chain
    }
}

export class RegisterService {
    
    public static getLocationsAddress = (zipcode: string) : Promise<{}> => {
        const target = `https://viacep.com.br/ws/${zipcode}/json`;
        return Api.get(target)
    }

    public static setTargetWallet = async (address:Address) : Promise<{}> => {
        let target = ``;
        await Api.baseUrlGenerator(`client`).then( envResponse => {
            target = `${envResponse}/createWallet`;
        });
        return Api.post(target, {address})
    }

    public static entityRegister = async (hash_address:string, password: string, nickname: string = '', chain: string): Promise<RegisterResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signup`;
        });
        const payload : RegisterPayload = createPayloadLoginAndRegister(hash_address,password,nickname,chain);
        return Api.post(target, payload);
    }

    public static entityLogin = async (hash_address:string, password: string, nickname?: string): Promise<LoginResponse> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signin`;
        });
        const payload : RegisterPayload = createPayloadLoginAndRegister(hash_address,password,nickname);
        return Api.post(target, payload)
    }

    public static getUserPhrase = async (hash:string, chain:string) : Promise<{}> => {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/loginRandomMessage`;
        });        
        const payload = {
            "hash_address": hash, 
            chain
        }
        return Api.post(target, payload);
    }

    public static makeSignup = async (signature:string, proof_message:string, flow: string, password: string, nickname: string, hash_address: string, chain:string) : Promise<any>=> {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signup`;
        });
        const payload = { flow, proof_message, signature, password, nickname, hash_address, chain}
        return Api.post(target, payload);
    }

    public static makeSignin = async (signature:string, proof_message:string, flow: string, hash_address: string) : Promise<any>=> {
        let target = ``;
        await Api.baseUrlGenerator(`base`).then( envResponse => {
            target = `${envResponse}/signin`;
        });
        const payload = { flow, proof_message, signature, hash_address}
        return Api.post(target, payload);
    }

}